/** Strip duplicate-row suffixes like `uuid #7` (legacy DB rows). */
export function canonicalExecutionId(id: string | null | undefined): string {
  return String(id || "")
    .trim()
    .replace(/ #\d+$/, "");
}

export function isGhostExecutionId(id: string | null | undefined): boolean {
  const trimmed = String(id || "").trim();
  return trimmed !== canonicalExecutionId(trimmed);
}
